import { render, staticRenderFns } from "./insurers.vue?vue&type=template&id=1305137c&scoped=true"
import script from "./insurers.vue?vue&type=script&lang=js"
export * from "./insurers.vue?vue&type=script&lang=js"
import style0 from "./insurers.vue?vue&type=style&index=0&id=1305137c&prod&lang=css"
import style1 from "./insurers.vue?vue&type=style&index=1&id=1305137c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305137c",
  null
  
)

export default component.exports